import * as Sentry from '@sentry/react';

import { SENTRY_DSN } from './constants';

Sentry.init({
  dsn: SENTRY_DSN,
  environment: import.meta.env.MODE,
});

const SentryErrorBoundary = Sentry.ErrorBoundary;

export { SentryErrorBoundary, Sentry };
